/**
 * Contracts wire-format version.
 *
 * Bump when the `/api/mobile/v1/*` wire format makes a breaking change
 * (renamed/removed fields, type-narrowing changes, enum-value removals).
 * Additive changes (new optional fields, new enum members at the END of an
 * enum) do NOT require a bump.
 *
 * Phase 03 establishes the v1 surface area; subsequent milestones move to
 * v2/v3 in lockstep with API URL versioning.
 */
export const CONTRACTS_VERSION = "v1" as const;

export type ContractsVersion = typeof CONTRACTS_VERSION;
